import React, { Component } from 'react';
import getOrderResult from '../../../services/getOrderResult'
import * as translationUtils from '../../../common-utils/translation_utils'

/**
 * Result Class renders results list
 */
class Result extends Component {

  
  orderData = [];
  $ = window.jQuery;

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      once : false
    };
  }

  componentDidMount(){
    window.loader(false);
    window.paginate(this.props.pageNumber, this.props.pageLength);
    window.resultClass = this;
    this.getMoreResult();
    window.jQuery('#js-ph-datatable_previous').text(translationUtils.getTranslation(716,'Previous'));
    window.jQuery('#js-ph-datatable_next').text(translationUtils.getTranslation(717,'Next'));
    window.jQuery('#js-ph-datatable_length label #show_dt_text').text(translationUtils.getTranslation(1354,'Show'));
    window.jQuery('#js-ph-datatable_length label #entries_dt_text').text(translationUtils.getTranslation(1849,'Entries'));
    window.jQuery('#js-ph-datatable_length label #show_dt_text').parent().css({'width':'auto','display':'flex'});
        window.jQuery('select[name=js-ph-datatable_length]').css('width','65px');
  }

  componentWillMount(){
    if(this.state.error===null){
      this.setState({
        isLoaded: true,
        items: this.props.data
      });
    }
  }

  getMoreResult=()=>{
    this.$('#js-ph-datatable').on( 'page.dt length.dt', function () {
      var info = window.dataTable.page.info();
      if(info.pages-info.page===1 && window.moreResults){
        let apiUrl = window.sessionStorage.getItem("apiUrl");
        apiUrl = apiUrl.substring(0,apiUrl.lastIndexOf('=')+1)+info.end;
        getOrderResult(window.resultClass, apiUrl, window.sessionStorage.getItem("token"));
      }
      setTimeout(function(){
        window.jQuery('#js-ph-datatable_previous').text(translationUtils.getTranslation(716,'Previous'));
        window.jQuery('#js-ph-datatable_next').text(translationUtils.getTranslation(717,'Next'));
        window.jQuery('#js-ph-datatable_length label #show_dt_text').text(translationUtils.getTranslation(1354,'Show'));
        window.jQuery('#js-ph-datatable_length label #entries_dt_text').text(translationUtils.getTranslation(1849,'Entries'));
        window.jQuery('#js-ph-datatable_length label #show_dt_text').parent().css({'width':'auto','display':'flex'});
        window.jQuery('select[name=js-ph-datatable_length]').css('width','65px');
      },10);
   });
  }

  setResultdata(data, authExpired=false, moreResults, total){
    window.moreResults = moreResults;
    let pageInfo = window.dataTable.page.info();
    this.props.callbackFromParent(this.state.items.concat(data), pageInfo.page, pageInfo.length);
  }




  /**
   * Order Details Refining for ease of render (Level 2 data).
   * Handles Orders with single and multiple Parts.
   * @param {JSON} orderData 
   * @param {JSON} orderLine 
   * @param {boolean} isMultiple 
   */
  getOrderItemDetail(orderData, orderLine, isMultiple = false){

    if(isMultiple){
      orderData = JSON.parse('{}');
    }

    orderData.partNumber = orderLine.Item.ItemID;
    orderData.qty = orderLine.OrderedQty;
    if(orderLine.ShipmentLines.ShipmentLine!==undefined){
      if(Array.isArray(orderLine.ShipmentLines.ShipmentLine)){
        orderLine.ShipmentLines.ShipmentLine = orderLine.ShipmentLines.ShipmentLine[0];
      }
      if(orderLine.ShipmentLines.ShipmentLine.Shipment.ExpectedDeliveryDate!==undefined){
        let expDate = new Date(orderLine.ShipmentLines.ShipmentLine.Shipment.ExpectedDeliveryDate);
        orderData.expectedDeliveryDate = expDate.toLocaleDateString('en-US');
      }else{
        orderData.expectedDeliveryDate = '';
      }
      if(orderLine.ShipmentLines.ShipmentLine.Shipment.Containers.Container!==undefined)
        orderData.trackingNumber = orderLine.ShipmentLines.ShipmentLine.Shipment.Containers.Container.TrackingNo;
      else
        orderData.trackingNumber = '';
      orderData.carrier = orderLine.ShipmentLines.ShipmentLine.Shipment.SCAC;
      let shipDate = new Date(orderLine.ShipmentLines.ShipmentLine.Shipment.ShipDate);
      orderData.shipDate = shipDate.toLocaleDateString('en-US');
    }else{
      orderData.expectedDeliveryDate = '';
      orderData.trackingNumber = '';
      orderData.carrier = '';
      orderData.shipDate = '';
    }
    if(orderLine.ReqShipDate!==undefined){
      let reqShipDate = new Date(orderLine.ReqShipDate);
      orderData.requiredShipingDate = reqShipDate.toLocaleDateString('en-US');
    }else{
      orderData.requiredShipingDate = '';
    }
    if(orderLine.OrderStatuses.OrderStatus!==undefined){
      let orderStatus = orderLine.OrderStatuses.OrderStatus;
      if(Array.isArray(orderStatus)){
        let statusPriority = 0;
        for(let i=0;i<orderStatus.length;i++){
          if(statusPriority<orderStatus[i].Status){
            statusPriority = orderStatus[i].Status;

            if(orderStatus[i].StatusDescription.toLowerCase().indexOf('acknowledge')<0){
              orderData.status = orderStatus[i].StatusDescription;
            }else{
              orderData.status = 'Accepted';
            }
          }
        }
      }else{
        if(orderStatus.StatusDescription.toLowerCase().indexOf('acknowledge')<0){
          orderData.status = orderStatus.StatusDescription;
        }else{
          orderData.status = 'Accepted';
        }
      }
    }else{
      orderData.status = '';
    }
    return orderData;
  }

  /**
   * Refines Level 1 Order Data
   * @param {JSON} order 
   */
  getOrderData(order){
    let orderData = JSON.parse('{}');
    orderData.orderNumber = order.OrderNo;
    //console.log(orderData.orderNumber);
    orderData.customerPONo = order.CustomerPONo;
    orderData.orderDate = order.OrderDate;//new Date(order.OrderDate).toLocaleDateString('en-US');
    if(Array.isArray(order.OrderLine)){
      orderData.haveMultipleItems = true;
      orderData.expectedDeliveryDate = '';
      orderData.trackingNumber = translationUtils.getTranslation(1851,'Multiple Tracking Numbers');
      orderData.requiredShipingDate = '';
      orderData.status = '';
      orderData.child = JSON.parse('[]');

      for(let i=0;i<order.OrderLine.length;i++){
        orderData.child[i] = this.getOrderItemDetail(orderData, order.OrderLine[i], true);
      }

    }else{
      orderData.haveMultipleItems = false;
      orderData = this.getOrderItemDetail(orderData, order.OrderLine);
    }
    
    if(orderData.status==="Shipment Delayed"){
      orderData.status='Delayed';
    }

    if(orderData.status==='Accepted'){
      orderData.status=translationUtils.getTranslation(1843,'Accepted');
    }else if(orderData.status==='Delayed'){
      orderData.status=translationUtils.getTranslation(1844,'Delayed');
    }else if(orderData.status==='Held'){
      orderData.status=translationUtils.getTranslation(1845,'Held');
    }else if(orderData.status==='Shipped'){
      orderData.status=translationUtils.getTranslation(1846,'Shipped');
    }
   
    return orderData;
  }

  /**
   * Makes accordian data for multiple orders.
   * @param {JSON} jsonData 
   */
  makeAndGetElement(jsonData){

    let head = '<tr class="lineItems1">'+
    '  <td colspan="7">'+
    '      <div class="contain-table">'+
    '          <table class="ph-table__default ph-table__nested">'+
    '              <thead class="ph-table__header">'+
    '                  <tr class="ph-table__row"> '+
    '                    <th class="ph-table__title" scope="col">Part Number</th>'+
    '                    <th class="ph-table__title" scope="col">Qty</th>'+
    '                    <th class="ph-table__title" scope="col">Ship Date</th>'+
    '                    <th class="ph-table__title" scope="col">Carrier</th>'+
    '                    <th class="ph-table__title" scope="col">Required Date</th>'+
    '                    <th class="ph-table__title" scope="col">Tracking Number</th>'+
    '                    <th class="ph-table__title" scope="col">Status</th>'+
    '                  </tr>'+
    '                </thead>'+
    '                <tbody class="ph-table__body">';
    
    let tail =   '                </tbody>'+
    '          </table>'+
    '      </div>'+
    '  </td>'+
    '</tr>';

    let dataString = '';
    if(Array.isArray(jsonData)){
    jsonData.map((item) => (
      dataString = dataString+'<tr class="ph-table__row" >'+
            '                    <td class="ph-table__cell"><a href="#">'+item.partNumber+'</a></td>'+
            '                    <td class="ph-table__cell">'+item.qty+'</td>'+
            '                    <td class="ph-table__cell">'+item.shipDate+'</td>'+
            '                    <td class="ph-table__cell">'+item.carrier+'</td>'+
            '                    <td class="ph-table__cell">'+item.requiredShipingDate+'</td>'+
            '                    <td class="ph-table__cell"><a href="#">'+item.trackingNumber+'</a></td>'+
            '                    <td class="ph-table__cell '+item.status.toLowerCase()+'">'+item.status.toUpperCase()+'</td>'+
            '                  </tr>'
    ));
    }else{
      dataString = dataString+'<tr class="ph-table__row" >'+
            '                    <td class="ph-table__cell"><a href="#">'+jsonData.partNumber+'</a></td>'+
            '                    <td class="ph-table__cell">'+jsonData.qty+'</td>'+
            '                    <td class="ph-table__cell">'+jsonData.shipDate+'</td>'+
            '                    <td class="ph-table__cell">'+jsonData.carrier+'</td>'+
            '                    <td class="ph-table__cell">'+jsonData.requiredShipingDate+'</td>'+
            '                    <td class="ph-table__cell"><a href="#">'+jsonData.trackingNumber+'</a></td>'+
            '                    <td class="ph-table__cell '+jsonData.status.toLowerCase()+'">'+jsonData.status.toUpperCase()+'</td>'+
            '                  </tr>'
    }
    return head+dataString+tail;
  }

  /**
   * Handles View Shippment click to show multiple orders.
   */

  handleShipmentClick=(event, items)=>{
    let el = event.target;
    let jQuery = window.jQuery;
    if(el.parentElement.parentElement.className.indexOf('active')>1){
      jQuery(el.parentElement.parentElement).removeClass('active');
      if(Array.isArray(items))
      jQuery(el.parentElement.parentElement.lastElementChild.children).removeClass('active')
      jQuery(el).parent().parent().next().remove();
    }else{
      jQuery(el.parentElement.parentElement).addClass('active');
      if(Array.isArray(items))
      jQuery(el.parentElement.parentElement.lastElementChild.children).addClass('active')
        jQuery(this.makeAndGetElement(items)).insertAfter(jQuery(el).parent().parent());
    }
  }
  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>....</div>;
    } else{
        return (
          <div className="contain-table">
              <div className="ph-table__exports">
                <h4 className="margin-right-auto">{translationUtils.getTranslation(1863, 'Your Orders')}</h4>
                <span className="ph-table__exports-options">
                  <a href="#"><i className="icon fas fa-envelope"></i>{translationUtils.getTranslation(408, 'Email')}</a>
                  <a href="#"><i className="icon fas fa-print"></i>{translationUtils.getTranslation(1066, 'Print')} </a>
                </span>
              </div>
            <table className="ph-table" id="js-ph-datatable">
              <thead className="ph-table__header">
                <tr className="ph-table__row">
                  <th className="ph-table__title" scope="col" key="0" style={{display:'none'}} >Order Date</th>
                  <th className="ph-table__title" scope="col" key="1">{translationUtils.getTranslation(1852, 'Order Number')}</th>
                  <th className="ph-table__title" scope="col"  key="2">{translationUtils.getTranslation(1853, 'Customer PO')}</th>
                  <th className="ph-table__title" scope="col" key="3">{translationUtils.getTranslation(1854, 'Expected Delivery Date')}</th>
                  <th className="ph-table__title" scope="col" key="4">{translationUtils.getTranslation(1855, 'Required Date')}</th>
                  <th className="ph-table__title" scope="col" key="5">{translationUtils.getTranslation(1856, 'Tracking Number')}</th>
                  <th className="ph-table__title" scope="col" key="6">{translationUtils.getTranslation(1842, 'Status')}</th>
                </tr>
              </thead>
              <tbody className="ph-table__body">
               
              {items.map((item, index) => (
                this.orderData[index] = this.getOrderData(item),
                  <>
                   {                  
                       (this.orderData[index].haveMultipleItems)?(
                        <tr className="ph-table__row" >
                          <td className="ph-table__cell" style={{display:'none'}}>{this.orderData[index].orderDate}</td>
                          <td className="ph-table__cell"><a href="javascript:void(0);" onClick={(e)=>this.handleShipmentClick(e, this.orderData[index].child)}>{this.orderData[index].orderNumber}</a></td>
                          <td className="ph-table__cell">{this.orderData[index].customerPONo}</td>    
                          <td className="ph-table__cell">{this.orderData[index].expectedDeliveryDate}</td>
                          <td className="ph-table__cell">{this.orderData[index].requiredShipingDate}</td>
                          <td className="ph-table__cell">{this.orderData[index].trackingNumber}</td>
                          <td><button onClick={(e)=>this.handleShipmentClick(e, this.orderData[index].child)} className="round-button accent-button toggler small-button" data-multi-track="1">{translationUtils.getTranslation(1850,'View Shipments')}</button></td>
                      </tr>
                       ):(
                        <tr className="ph-table__row" >
                          <td className="ph-table__cell" style={{display:'none'}}>{this.orderData[index].orderDate}</td>
                          <td className="ph-table__cell"><a href="javascript:void(0);" onClick={(e)=>this.handleShipmentClick(e, this.orderData[index])} >{this.orderData[index].orderNumber}</a></td>
                          <td className="ph-table__cell">{this.orderData[index].customerPONo}</td>    
                          <td className="ph-table__cell">{this.orderData[index].expectedDeliveryDate}</td>
                          <td className="ph-table__cell">{this.orderData[index].requiredShipingDate}</td>
                          <td className="ph-table__cell"><a href='javascript:void(0);'>{this.orderData[index].trackingNumber}</a></td>
                          <td className={"ph-table__cell "+this.orderData[index].status.toLowerCase()}>{this.orderData[index].status.toUpperCase()}</td>
                      </tr>
                       )
                    }
                  </>
                
              ))}
              </tbody>
            </table>
                </div>
        );
      }
  }

}

export default Result;